module.exports = __webpack_public_path__ + "static/media/BNB_CAKE_Cake.72618f0f.png";